export default __webpack_public_path__ + "static/media/chom-mier-wei-go-chrieseli-guenne.8269b070.pdf";